const PLATFORM_FIELDS = [
  ["X", "twitter"],
  ["Instagram", "instagram"],
  ["Bluesky", "bluesky"],
  ["Telegram", "telegram"],
  ["Faphouse", "faphouse"],
  ["OnlyFans", "onlyfans"],
  ["OnlyFans Free", "onlyfans_free"],
  ["JustForFans", "justforfans"],
  ["TikTok", "tiktok"],
  ["Link in bio", "link_in_bio"],
];

const text = (value) => String(value ?? "").trim();
const escapeText = (value) => text(value)
  .replace(/\\/g, "\\\\")
  .replace(/\r\n|\r|\n/g, "\\n")
  .replace(/;/g, "\\;")
  .replace(/,/g, "\\,");

function foldLine(line) {
  const encoder = new TextEncoder();
  let folded = "";
  let byteLength = 0;
  for (const character of line) {
    const characterBytes = encoder.encode(character).length;
    if (byteLength + characterBytes > 75) {
      folded += "\r\n ";
      byteLength = 1;
    }
    folded += character;
    byteLength += characterBytes;
  }
  return folded;
}

function serializeRecord(record) {
  const name = text(record.stage_name || record.type_details?.preferred_name)
    .replace(/^\d+TODO\s*/i, "") || "Unknown contact";
  const role = text(record.position || record.type);
  const accountReferences = PLATFORM_FIELDS
    .map(([label, key]) => [label, text(record[key])])
    .filter(([, value]) => value)
    .map(([label, value]) => `${label}: ${value}`);
  const notes = [text(record.notes), accountReferences.length ? `Accounts: ${accountReferences.join("; ")}` : ""]
    .filter(Boolean)
    .join("\n\n");

  const lines = ["BEGIN:VCARD", "VERSION:3.0", `FN:${escapeText(name)}`, `N:;${escapeText(name)};;;`];
  if (role) lines.push(`TITLE:${escapeText(role)}`);
  if (text(record.email)) lines.push(`EMAIL;TYPE=INTERNET:${escapeText(record.email)}`);
  if (text(record.phone)) lines.push(`TEL;TYPE=VOICE:${escapeText(record.phone)}`);
  if (notes) lines.push(`NOTE:${escapeText(notes)}`);
  lines.push("END:VCARD");
  return lines.map(foldLine).join("\r\n");
}

export function isCrewVCardAdmin(user, token) {
  if (!user || typeof token !== "string") return false;
  try {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3 || !tokenParts[1]) return false;
    let encodedPayload = tokenParts[1].replace(/-/g, "+").replace(/_/g, "/");
    encodedPayload += "=".repeat((4 - encodedPayload.length % 4) % 4);
    const payload = JSON.parse(globalThis.atob(encodedPayload));
    const authenticatedUserId = typeof user === "string" ? user : user.id;
    return Boolean(authenticatedUserId && payload?.sub)
      && String(payload.sub) === String(authenticatedUserId)
      && (payload.user_type === "admin" || payload.role === "admin");
  } catch {
    return false;
  }
}

export function canExportCrewVCard(scope, user, token) {
  return scope === "crew" && isCrewVCardAdmin(user, token);
}

export function getCrewVCardExportRecords(filteredRecords, selectedIds) {
  const selected = new Set(selectedIds || []);
  return selected.size
    ? filteredRecords.filter((record) => selected.has(record.id))
    : filteredRecords;
}

export function serializeCrewVCards(records) {
  if (!Array.isArray(records) || !records.length) return "";
  return `${records.map(serializeRecord).join("\r\n")}\r\n`;
}